import { Box } from '@material-ui/core';
import { CustomAddButton } from '../buttons/custom-add-button';
import { CustomMinusButton } from '../buttons/custom-minus-button';

import StringUtils from '../../../utils/StringUtils';
import useStyles from './styles';

export function CustomMeasureValueSelector(props: Props) {
  const {
    value,
    maxValue,
    minValue,
    measureText,
    onIncrease,
    onDecrease,
  } = props;

  const _classes = useStyles();

  return (
    <Box className={_classes.root}>
      <CustomMinusButton disabled={value <= minValue} onClick={onDecrease} />
      <Box className={_classes.valueContainer}>
        <span className={_classes.value}>{`${value}’`}</span>
        {!StringUtils.isNullOrEmpty(measureText) && <span>{measureText}</span>}
      </Box>
      <CustomAddButton disabled={value >= maxValue} onClick={onIncrease} />
    </Box>
  );
}

interface Props {
  value: number;
  minValue: number;
  maxValue: number;
  measureText?: string;
  onDecrease: () => void;
  onIncrease: () => void;
}
